/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.user_token_session.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.user_token_session = {};
proto.witbooking.backoffice.user_token_session.v1 = require('./user_token_session_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.user_token_session.v1.UserTokenSessionAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.user_token_session.v1.UserTokenSessionAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionRequest,
 *   !proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse>}
 */
const methodDescriptor_UserTokenSessionAPI_GetUserTokenSession = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/GetUserTokenSession',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionRequest,
  proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse,
  /**
   * @param {!proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionRequest,
 *   !proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse>}
 */
const methodInfo_UserTokenSessionAPI_GetUserTokenSession = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse,
  /**
   * @param {!proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.user_token_session.v1.UserTokenSessionAPIClient.prototype.getUserTokenSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/GetUserTokenSession',
      request,
      metadata || {},
      methodDescriptor_UserTokenSessionAPI_GetUserTokenSession,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.user_token_session.v1.GetUserTokenSessionResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.user_token_session.v1.UserTokenSessionAPIPromiseClient.prototype.getUserTokenSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/GetUserTokenSession',
      request,
      metadata || {},
      methodDescriptor_UserTokenSessionAPI_GetUserTokenSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionRequest,
 *   !proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse>}
 */
const methodDescriptor_UserTokenSessionAPI_CreateUserTokenSession = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/CreateUserTokenSession',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionRequest,
  proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse,
  /**
   * @param {!proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionRequest,
 *   !proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse>}
 */
const methodInfo_UserTokenSessionAPI_CreateUserTokenSession = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse,
  /**
   * @param {!proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.user_token_session.v1.UserTokenSessionAPIClient.prototype.createUserTokenSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/CreateUserTokenSession',
      request,
      metadata || {},
      methodDescriptor_UserTokenSessionAPI_CreateUserTokenSession,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.user_token_session.v1.CreateUserTokenSessionResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.user_token_session.v1.UserTokenSessionAPIPromiseClient.prototype.createUserTokenSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/CreateUserTokenSession',
      request,
      metadata || {},
      methodDescriptor_UserTokenSessionAPI_CreateUserTokenSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionRequest,
 *   !proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse>}
 */
const methodDescriptor_UserTokenSessionAPI_DeleteUserTokenSession = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/DeleteUserTokenSession',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionRequest,
  proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse,
  /**
   * @param {!proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionRequest,
 *   !proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse>}
 */
const methodInfo_UserTokenSessionAPI_DeleteUserTokenSession = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse,
  /**
   * @param {!proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.user_token_session.v1.UserTokenSessionAPIClient.prototype.deleteUserTokenSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/DeleteUserTokenSession',
      request,
      metadata || {},
      methodDescriptor_UserTokenSessionAPI_DeleteUserTokenSession,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.user_token_session.v1.DeleteUserTokenSessionResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.user_token_session.v1.UserTokenSessionAPIPromiseClient.prototype.deleteUserTokenSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.user_token_session.v1.UserTokenSessionAPI/DeleteUserTokenSession',
      request,
      metadata || {},
      methodDescriptor_UserTokenSessionAPI_DeleteUserTokenSession);
};


module.exports = proto.witbooking.backoffice.user_token_session.v1;

